import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

export const InputErrors: React.FC<{
  errors?: Map<string, string>;
  viewId?: string;
  suffixid?: string;
}> = observer((props) => {
  const errorRef = useRef<HTMLSpanElement>(null);

  const errorLabels = () => {

    const spans: Array<React.ReactNode> = [];
    if (props.viewId) {
      const id = props.suffixid !== undefined ? props.viewId + props.suffixid : props.viewId;
      const error = props.errors?.get(id);
      if (error) {
        spans.push(
          <span
            ref={errorRef}
            className="text-red-600 text-sm font-medium mt-1 block"
            id={`${props.viewId}-feedback`}
            key={`${props.viewId}-feedback`}>
            {error}
          </span>,
        );
      } else {
        if (props.errors?.has("")) {
          let messages = props.errors?.get("");
          if (messages && messages.length > 0) {
            alert(messages[0]);
          }
        }
      }
    }
    return spans;
  };

  // Scroll to error when it appears
  useEffect(() => { 
    if (errorRef.current && props.viewId) {
      const id = props.suffixid !== undefined ? props.viewId + props.suffixid : props.viewId;
      const error = props.errors?.get(id);
      if (error) {
        // Scroll to the input field instead of the error message
        const inputElement = document.getElementById(props.viewId);
        if (inputElement) {
          const rect = inputElement.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = rect.top + scrollTop - 100; // 100px offset from top
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        } else {
          errorRef.current.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      }
    }
  }, [props.errors?.get(props?.viewId || '')]);

  return <>{errorLabels()}</>;
});
